export default "__VITE_ASSET__8a1b01cb__"